import {
	StyledButton,
	StyledSegmentedControl,
	StyledSlider,
} from '~/components/segmented-control/styles/segmented-control-style';

export type SegmentedControlItem = {
	key: string;
	label: string;
};

interface Props {
	items: SegmentedControlItem[];
	onChange: (item: SegmentedControlItem) => void;
	activeItem: string;
	id: string;
}

export const SegmentedControl = ({ items, onChange, activeItem, id }: Props) => {
	const activeIndex = items.findIndex((d) => d.key === activeItem);
	return (
		<StyledSegmentedControl id={id}>
			<StyledSlider $index={activeIndex} $count={items.length} />
			{items.map((item, index) => (
				<StyledButton key={index} onClick={() => onChange(item)}>
					{item.label}
				</StyledButton>
			))}
		</StyledSegmentedControl>
	);
};
